import(/* webpackMode: "eager" */ "/codebuild/output/src2856068797/src/rellify-web/src/app/organizations/page.tsx");
